"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Katal = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
/**
 * The derived unit for catalytic activity ( <code>kat</code> ).
 */
exports.Katal = UnitDivide.amountOfSubstanceByDuration("Katal", uom_1.BaseUnits.Mole, uom_1.BaseUnits.Second);
//# sourceMappingURL=catalytic-activity.js.map